import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WeeklyReportService {

  showReport = new BehaviorSubject(false);
  activeWeek = new BehaviorSubject(0);
  constructor() { }

  getReportsRead(allTaskStatuses:any){
    let weeksRead:any = [];
    allTaskStatuses.forEach((status:any) => {
      if(status.task_id == 'readWeeklyReport'){
        weeksRead.push(+status.status);
      }
    });
    return weeksRead;
  }
}
